module.exports = __webpack_public_path__ + "static/media/octorion-work-intro.7c6e7661.svg";